<template>
  <div
    class="ecogas-floating-menu"
    :class="{ 'ecogas-floating-menu--smaller': !status && whiteMenu }">
    <div class="default-container default-container--menu">
      <div class="menu-wrapper">
        <div class="logo-menu">

          <router-link :to="{ name: `${lang}-home`, params: { lang } }">
            <svg :class="{ 'logo-menu_hide': logoOpacity }" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="564.588" height="141.699" viewBox="0 0 564.588 141.699">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rettangolo_522" data-name="Rettangolo 522" width="140.016" height="141.7" fill="#fff"/>
    </clipPath>
    <clipPath id="clip-path-2">
      <rect id="Rettangolo_521" data-name="Rettangolo 521" width="188.49" height="31.111" fill="#fff"/>
    </clipPath>
  </defs>
  <g id="Raggruppa_594" data-name="Raggruppa 594" transform="translate(6708.947 19504.336)">
    <g id="Raggruppa_593" data-name="Raggruppa 593" transform="translate(-6708.947 -19504.336)">
      <g id="Raggruppa_431" data-name="Raggruppa 431" clip-path="url(#clip-path)">
        <path id="Tracciato_647" data-name="Tracciato 647" d="M306.8,368.319a42.127,42.127,0,0,0,63.617,52.958A42.057,42.057,0,1,1,306.8,368.319" transform="translate(-242.953 -306.728)" fill="#fff"/>
        <path id="Tracciato_648" data-name="Tracciato 648" d="M159.234,306.2a55.022,55.022,0,1,1,41.252-100.389A55.016,55.016,0,0,0,159.234,306.2" transform="translate(-96.966 -164.498)" fill="#fff"/>
        <path id="Tracciato_649" data-name="Tracciato 649" d="M140.016,53.423A71.276,71.276,0,0,0,8.688,104.565,74.043,74.043,0,0,1,2.475,89.724,71.127,71.127,0,0,1,139.146,50.331q.47,1.536.87,3.092" transform="translate(0 0)" fill="#fff"/>
      </g>
    </g>
    <path id="Tracciato_739" data-name="Tracciato 739" d="M105.718,2.859V.517h13.935v15.2h-2.342V7.811a12.374,12.374,0,0,1-3.724,5.893,10.251,10.251,0,0,1-7.1,2.438,12.239,12.239,0,0,1-9.5-4.2A15.544,15.544,0,0,1,93.2,1.132,15.48,15.48,0,0,1,97-9.694a12.407,12.407,0,0,1,9.6-4.184,12.87,12.87,0,0,1,8.138,2.534,12.844,12.844,0,0,1,4.491,6.795h-2.726a11.132,11.132,0,0,0-3.666-5.163,9.947,9.947,0,0,0-6.238-1.9,9.581,9.581,0,0,0-7.639,3.589A13.7,13.7,0,0,0,95.93,1.132a13.623,13.623,0,0,0,3.052,9.175,9.776,9.776,0,0,0,7.774,3.57,9.846,9.846,0,0,0,7.351-2.917q2.86-2.917,2.9-8.1Zm27.37-1.036V13.339h16.084v2.38H130.44V-13.456h18.388v2.38H133.089V-.557h15.47v2.38Zm28.752,13.9h-2.649V-13.456h2.649Zm18.618,0h-2.917L162.11-13.456h2.879Zm2.879,0H180.69V-13.456h2.649Zm14.4-13.9V13.339h16.084v2.38H195.085V-13.456h18.388v2.38H197.734V-.557H213.2v2.38Zm39.616,1,8.1,12.9h-3.071l-7.87-12.553h-8.023V15.719h-2.649V-13.456h10.288a11.243,11.243,0,0,1,7.332,2.226,7.456,7.456,0,0,1,2.726,6.1A7.561,7.561,0,0,1,242.36.057,8.976,8.976,0,0,1,237.35,2.821Zm-3.148-13.9h-7.716V.786H234.2a8.288,8.288,0,0,0,5.3-1.555,5.248,5.248,0,0,0,1.958-4.357A5.3,5.3,0,0,0,239.5-9.5,8.218,8.218,0,0,0,234.2-11.076Zm44.722,26.795h-2.8l-3.57-9.4H257.235l-3.57,9.4h-2.841l11.171-29.175h2.764l-6.6,17.39H271.63l-6.641-17.39h2.764Zm1.459-29.175h22.61v2.38h-9.981V15.719h-2.649V-11.076h-9.981Zm41.267,29.6a12.813,12.813,0,0,1-9.866-4.165,15.37,15.37,0,0,1-3.839-10.845,15.37,15.37,0,0,1,3.839-10.845,12.813,12.813,0,0,1,9.866-4.165,12.857,12.857,0,0,1,9.9,4.165,15.37,15.37,0,0,1,3.839,10.845,15.37,15.37,0,0,1-3.839,10.845A12.857,12.857,0,0,1,321.649,16.141Zm0-2.265a9.953,9.953,0,0,0,7.908-3.57,13.569,13.569,0,0,0,3.071-9.175,13.569,13.569,0,0,0-3.071-9.175,9.953,9.953,0,0,0-7.908-3.57,9.969,9.969,0,0,0-7.889,3.57,13.516,13.516,0,0,0-3.09,9.175,13.516,13.516,0,0,0,3.09,9.175A9.969,9.969,0,0,0,321.649,13.876ZM358.809,2.821l8.1,12.9h-3.071L355.968,3.166h-8.023V15.719H345.3V-13.456h10.288a11.243,11.243,0,0,1,7.332,2.226,7.456,7.456,0,0,1,2.726,6.1A7.561,7.561,0,0,1,363.818.057,8.977,8.977,0,0,1,358.809,2.821Zm-3.148-13.9h-7.716V.786h7.716a8.288,8.288,0,0,0,5.3-1.555,5.248,5.248,0,0,0,1.958-4.357A5.3,5.3,0,0,0,360.958-9.5,8.218,8.218,0,0,0,355.661-11.076Z" transform="translate(-6523.68 -19423.318)" fill="#fff"/>
    <g id="Raggruppa_592" data-name="Raggruppa 592" transform="translate(-6625.949 -19437.75)">
      <path id="Tracciato_641" data-name="Tracciato 641" d="M76.034,2.491l5.17,14.6H70.848ZM79.856.2H75.721v0H71.669L60.807,30.442h5.278l3.148-8.829H82.81l3.148,8.829h5.27L80.363.2Z" transform="translate(68.873 0.229)" fill="#fff"/>
      <g id="Raggruppa_426" data-name="Raggruppa 426" transform="translate(0 0)">
        <g id="Raggruppa_425" data-name="Raggruppa 425" clip-path="url(#clip-path-2)">
          <path id="Tracciato_642" data-name="Tracciato 642" d="M35.406,20.439a8.469,8.469,0,0,1-8.744,6.321,7.82,7.82,0,0,1-6.4-3.086,12.528,12.528,0,0,1-2.54-8.119,12.644,12.644,0,0,1,2.51-8.149,7.932,7.932,0,0,1,6.552-3.073,8.084,8.084,0,0,1,5.231,1.687,10.4,10.4,0,0,1,3.176,4.6l.128.35h5.089l-.171-.663a13.582,13.582,0,0,0-4.773-7.486A13.65,13.65,0,0,0,26.786.007,13.3,13.3,0,0,0,16.6,4.342a15.959,15.959,0,0,0-3.98,11.207,15.958,15.958,0,0,0,3.98,11.2A13.165,13.165,0,0,0,26.643,31.09a14.365,14.365,0,0,0,8.723-2.619,14.286,14.286,0,0,0,5.071-7.705l.213-.685H35.532Z" transform="translate(14.285 0.003)" fill="#fff"/>
          <path id="Tracciato_643" data-name="Tracciato 643" d="M4.943,17.121H19.8V12.6H4.943V4.724H20.068V.2H0V30.441l20.414,0V25.922H4.943Z" transform="translate(0 0.23)" fill="#fff"/>
          <path id="Tracciato_644" data-name="Tracciato 644" d="M99.235,16.153a14.963,14.963,0,0,0-6.769-2.945l-3.645-.8a15.557,15.557,0,0,1-4.79-1.67,2.762,2.762,0,0,1-1.164-2.493,3.181,3.181,0,0,1,1.657-2.772,8,8,0,0,1,4.412-1.143c3.653,0,5.82,1.429,6.626,4.368l.107.392h5.076l-.113-.625a9.5,9.5,0,0,0-3.839-6.17A12.974,12.974,0,0,0,88.934.009a12.54,12.54,0,0,0-7.791,2.44,7.548,7.548,0,0,0-3.263,6.2c0,4.233,2.79,6.991,8.287,8.2l3.645.806a19.356,19.356,0,0,1,5.332,1.757,2.9,2.9,0,0,1,1.28,2.713,3.822,3.822,0,0,1-1.868,3.306,9.9,9.9,0,0,1-5.545,1.329,7.679,7.679,0,0,1-4.747-1.429,5.743,5.743,0,0,1-2.212-4.052l-.062-.463H76.872l.094.614A10.812,10.812,0,0,0,80.924,28.5a12.628,12.628,0,0,0,8.089,2.593,14.515,14.515,0,0,0,8.919-2.559,8.208,8.208,0,0,0,3.476-6.837,7.11,7.11,0,0,0-2.173-5.545" transform="translate(87.069 0)" fill="#fff"/>
          <path id="Tracciato_645" data-name="Tracciato 645" d="M57.688,18.428h10.5a8.773,8.773,0,0,1-2.429,6.016,8.618,8.618,0,0,1-6.268,2.325A8.24,8.24,0,0,1,52.8,23.7a12.34,12.34,0,0,1-2.6-8.142,12.518,12.518,0,0,1,2.546-8.147,8.032,8.032,0,0,1,6.592-3.065A8.589,8.589,0,0,1,64.6,5.888a9.023,9.023,0,0,1,3.062,4.284l.128.352h5.1l-.173-.665a12.732,12.732,0,0,0-4.692-7.251,14.179,14.179,0,0,0-8.688-2.6A13.386,13.386,0,0,0,49.076,4.344,15.959,15.959,0,0,0,45.1,15.551a16.022,16.022,0,0,0,3.958,11.184h0a12.991,12.991,0,0,0,9.97,4.357,10.318,10.318,0,0,0,7.01-2.357,12.007,12.007,0,0,0,2.668-3.306v5.242H73.15V13.9H57.688Z" transform="translate(51.064 0.001)" fill="#fff"/>
          <path id="Tracciato_646" data-name="Tracciato 646" d="M42.9.008A13.618,13.618,0,0,0,32.465,4.344a15.906,15.906,0,0,0-4,11.207,15.9,15.9,0,0,0,4,11.2h0a13.619,13.619,0,0,0,10.427,4.336,13.587,13.587,0,0,0,10.412-4.316,15.935,15.935,0,0,0,4.02-11.224,15.914,15.914,0,0,0-4-11.207A13.618,13.618,0,0,0,42.9.008m6.7,23.664a8.987,8.987,0,0,1-.921.926,8.874,8.874,0,0,1-12.514-.9,12.422,12.422,0,0,1-2.6-8.145,12.279,12.279,0,0,1,2.621-8.123,8.947,8.947,0,0,1,.975-.975,8.831,8.831,0,0,1,12.45.975,12.279,12.279,0,0,1,2.621,8.123,12.288,12.288,0,0,1-2.63,8.121" transform="translate(32.225 0.001)" fill="#fff"/>
        </g>
      </g>
    </g>
    <path id="Tracciato_740" data-name="Tracciato 740" d="M1.054-4.777A4.641,4.641,0,0,0,5.768-9.489,4.641,4.641,0,0,0,1.054-14.2,4.641,4.641,0,0,0-3.66-9.489,4.641,4.641,0,0,0,1.054-4.777Zm0-1.061A3.3,3.3,0,0,1-2.424-9.23v-.518a3.3,3.3,0,0,1,3.477-3.391A3.3,3.3,0,0,1,4.531-9.748v.518A3.3,3.3,0,0,1,1.054-5.839ZM.281-8.919h.747l1,1.812H3.192L2.007-9.074a1.367,1.367,0,0,0,.953-1.346A1.384,1.384,0,0,0,1.44-11.9H-.749v4.789H.281Zm0-.751v-1.424h.927a.6.6,0,0,1,.67.621v.181a.6.6,0,0,1-.67.621Z" transform="translate(-6150.127 -19427.709)" fill="#fff"/>
  </g>
</svg>

          </router-link>

        </div>

        <!-- HAMBURGER FINO A 1024 -->
        <div
          class="hamburger-menu-container show-still-large"
          :class="{ 'coloredBackground': backgroundHamburger }"
          @click="$_hamburgerClick">

          <div
            class="hamburger-menu"
            id="hamburger"
            :class="{ 'hamburger-menu-container--animate': status }"/>
        </div>

        <!-- MENU DESKTOP DOPO 1024 -->
        <div class="menu-desktop hide-still-large">

          <ul class="menu-desktop__list">
            <li>
              <router-link :to="{ name: `${lang}-impianto`, params: { lang } }">{{ $t('vociMenu.impianto') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-come-funziona`, params: { lang } }">{{ $t('vociMenu.comeFunziona') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-vantaggi`, params: { lang } }">{{ $t('vociMenu.vantaggi') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-azienda`, params: { lang } }">{{ $t('vociMenu.azienda') }}</router-link>
            </li>
            <li>
              <router-link :to="{ name: `${lang}-contatti`, params: { lang } }">{{ $t('vociMenu.contatti') }}</router-link>
            </li>
          </ul>
          <ul class="menu-desktop__languages-list">
            <li :class="{ 'router-link-active': lang === 'it' }">
              <span v-if="lang === 'it'">IT</span>
              <a v-else :href="$_convertRoute($route.name, lang, 'it')">IT</a>
            </li>
            <li :class="{ 'router-link-active': lang === 'en' }">
              <span v-if="lang === 'en'">EN</span>
              <a v-else :href="$_convertRoute($route.name, lang, 'en')">EN</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data: () => ({
    whiteMenu: false
  }),
  props: {
    lang: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      default: () => false
    },
    fastWhite: {
      type: Boolean,
      default: () => false
    },
    backgroundHamburger: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    logoOpacity: {
      get () {
        return false
        // return this.$route.meta.pageName === 'menu'
      }
    }
  },
  methods: {
    $_hamburgerClick () {
      if (['menu'].includes(this.$route.meta.pageName)) this.$router.back()
      else this.$router.push({ name: `${this.lang}-menu` })
    },
    $_updateScroll () {
      this.whiteMenu = (this.fastWhite && window.scrollY > 10) || window.scrollY >= window.innerHeight
      if (this.$route.meta.pageName === 'privacy-policy') this.whiteMenu = true
      if (this.$route.meta.pageName === 'not-found') this.whiteMenu = true
      if (this.$route.meta.pageName === 'cookie-policy') this.whiteMenu = true
    },
    $_convertRoute (routeName, currentLang, lang) {
      return this.$router.resolve({ name: _.replace(routeName, `${currentLang}-`, `${lang}-`) }).href
    }
  },
  mounted () {
    window.addEventListener('scroll', this.$_updateScroll)
    if (this.$route.meta.pageName === 'privacy-policy') this.whiteMenu = true
    if (this.$route.meta.pageName === 'not-found') this.whiteMenu = true
    if (this.$route.meta.pageName === 'cookie-policy') this.whiteMenu = true
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.$_updateScroll)
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .show-still-large{
    display: block;
  }
  .hide-still-large{
    display: none;
  }

  .logo-menu{
    display: inline-block;
    svg{
      opacity: 1;
      transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      width: 222px;
      height: auto;
    }
    svg.logo-menu_hide{
      opacity: 0;
    }

  }

  @media #{$large_mq} {
    .show-still-large{
      display: none;
    }
    .hide-still-large{
      display: block;
    }
  }

  .ecogas-floating-menu {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: transparent;

  .default-container--menu{
    background-color: #30AE8D;
    padding-top: 20px;
    padding-bottom: 20px;
    transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);

    @media #{$large_mq} {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
  &.ecogas-floating-menu--smaller .default-container--menu{
    /*
    padding-top: 20px;
    padding-bottom: 20px;
    */
  }
}

.ecogas-floating-menu, .ecogas-floating-menu .hamburger-menu:before, .ecogas-floating-menu .hamburger-menu:after, .ecogas-floating-menu .logo-menu path{
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1)
}

.menu-wrapper{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

.hamburger-menu-container{
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 35px;
  height: 55px;
  cursor: pointer;
}

.hamburger-menu{
  width: 35px;
  height: 43px;
  top: 25px;
}

.hamburger-menu,
.hamburger-menu:after,
.hamburger-menu:before {
  width: 35px;
  height: 2px;
}

.hamburger-menu {
  position: relative;
  background: #FFF;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
}
.hamburger-menu.hamburger-menu-container--animate {
  background: rgba(255, 255, 255, 0);
}

.hamburger-menu:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 10px;
  background: #FFF;
  transition: bottom 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu:after {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  background: #FFF;
  transition: top 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu.hamburger-menu-container--animate:after {
  top: 0;
  transform: rotate(45deg);
  transition: top 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu.hamburger-menu-container--animate:before {
  bottom: 0;
  transform: rotate(-45deg);
  transition: bottom 300ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu-container::before{
  content: '';
  position: absolute;
  top: 50%; left: 50%; transform: translate3d(-50%, -50%, 0);
  width: 58px; height: 58px;
  background-color: #304FFE;
  border-radius: 29px;
  opacity: 0;
  transition: opacity 600ms cubic-bezier(0.23, 1, 0.32, 1), transform 300ms 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.hamburger-menu-container.coloredBackground::before {
  opacity: 1;
}

.ecogas-floating-menu .menu-desktop__list{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  @include menu-link(#FFF);
  li{
    margin-left: 2rem;
    @media #{$xlarge_mq} {
      margin-left: 3rem;
    }
    @media #{$xxlarge_mq} {
      margin-left: 3.5rem;
    }

    a{
      font-size: .8rem;

      text-transform: uppercase;
      color: #FFF;
      text-decoration: none;
      transition: color 300ms cubic-bezier(0.23, 1, 0.32, 1);
      @media #{$large_mq} {
        font-size: .85rem;
      }
      @media #{$xlarge_mq} {
        font-size: .9rem;
      }
      @media #{$xxlarge_mq} {
        font-size: 1rem;
      }

    }
  }
}

@media #{$large_mq} {
  .menu-desktop{
    display: flex;
    flex-direction: row;
  }
}

.ecogas-floating-menu .menu-desktop__list a::before{
  position: absolute;
  left: -5px;
  bottom: -3.2rem;
  width: 0;
  content: "";
  height: 4px;
  background-color: #FFF;
  transition: width 600ms cubic-bezier(0.23, 1, 0.32, 1);
}
.ecogas-floating-menu.ecogas-floating-menu--smaller .menu-desktop__list a::before{
  /*
  bottom: -1.9rem;
  */
}

.menu-desktop__list a.router-link-active::before, .menu-desktop__list a:hover::before{
  width: calc(100% + 10px);
}

.menu-desktop__languages-list{
    display: flex;
    flex-direction: column;
    width: 28px;
    text-align: left;
    margin-left: 2.5rem;

    &::after{
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-top: 5px solid #fff;
      right: -5px;
      top: 8px;
      @media #{$xlarge_mq} {
        top: 8px;
      }
    }

    li{
      visibility: hidden;
      order: 2;
      position: absolute;
      top: 1.2rem;
    }

    &:hover li{
      visibility: visible;
    }

    li a, li span{
      font-size: .8rem;

      text-transform: uppercase;
      color: #FFF;
      text-decoration: none;
      transition: color 300ms cubic-bezier(0.23, 1, 0.32, 1);

      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      letter-spacing: 1px;

      @media #{$large_mq} {
        font-size: .85rem;
      }
      @media #{$xlarge_mq} {
        font-size: .9rem;
      }
      @media #{$xxlarge_mq} {
        font-size: 1rem;
      }

    }

    li.router-link-active{
      visibility: visible;
      order: 0;
      position: relative;
      top: auto;
    }

}

</style>
